// We could keep using moment, or we could take the time to slowly replace it overtime
// with a smaller library.  If we mostly just need formatting, dayjs or date-fns should work great.
// https://github.com/you-dont-need/You-Dont-Need-Momentjs

import moment from "moment-timezone"
import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(timezone)
dayjs.extend(utc)

export const dayjsWithTimezone = (timezone = App.currentOrganization.timezone) =>
  dayjs().tz(timezone)

// Attempt to check for international date styling
export const isInternational = () => momentDateFormat.startsWith("D")

// Return Locale DateTime unless a specific timeZone is passed like "America/Los_Angeles"
const dateWithTimeZone = (dateTime, timeZone) => {
  if (timeZone) {
    return new Date(dateTime).toLocaleString("en-US", { timeZone })
  }

  return new Date(dateTime)
}

export const longDateFormat = () => (isInternational() ? "MMMM D, YYYY" : "D MMMM, YYYY")

export const shortDateFormat = () => (isInternational() ? "D MMM, YYYY" : "MMM D, YYYY")

export const condensedMonthDayFormat = () => (isInternational() ? "D MMM" : "MMM D")

const dayjsFormat = (dateTime, formatDate, formatTime) => {
  const newDateFormat = formatDate ? `${formatDate}` : ""
  const newTimeFormat = formatTime ? `${formatDate ? ` [at] ` : ""}${formatTime}` : ""

  return dayjs(dateWithTimeZone(dateTime, App.currentOrganization.timezone)).format(
    newDateFormat + newTimeFormat
  )
}

export const formatDateTime = (
  dateTime,
  formatDate = momentDateFormat,
  formatTime = momentTimeFormat
) => dayjsFormat(dateTime, formatDate, formatTime)

export const formatDateTimeLong = dateTime => formatDateTime(dateTime, longDateFormat())

export const formatDateTimeShort = dateTime => formatDateTime(dateTime, shortDateFormat())

export const formatDate = (dateTime, formatDate = momentDateFormat) =>
  dayjsFormat(dateTime, formatDate, null)

export const formatDateLong = dateTime => formatDate(dateTime, longDateFormat())

export const formatDateShort = dateTime => formatDate(dateTime, shortDateFormat())

export const formatMonthDayCondensed = dateTime => formatDate(dateTime, condensedMonthDayFormat())

export const formatTime = (dateTime, formatTime = momentTimeFormat) =>
  dayjsFormat(dateTime, null, formatTime)

export const getDateDifference = (
  pastDate,
  futureDate,
  unit = "year",
  dateFormat = App.currentOrganization.momentDateTimeFormat
) => {
  const date1 = moment(pastDate)
  const date2 = futureDate ? moment(futureDate, dateFormat) : moment()

  return date2.diff(date1, unit)
}

export const VALID_MOMENT_DATE_TIME_FORMATS = [
  "h",
  "ha",
  "h:mm",
  "h:mma",
  "H:mm",
  "H",
  "YYYY-MM-DDTHH:mm:ssZ"
]

export const momentDateTime = (date, time) => {
  const momentDate = moment(date)

  if (time) {
    const momentTime = moment.tz(
      time,
      VALID_MOMENT_DATE_TIME_FORMATS,
      true,
      App.currentOrganization.timezone
    )

    if (momentTime.isValid()) {
      momentDate.set({
        hour: momentTime.hour(),
        minute: momentTime.minute()
      })
    }
  }

  return momentDate
}
